/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  IdNowIdVerificationDto,
  IdVerificationDto,
  InitiateIdVerificationRequestDto,
  OnfidoIdVerificationDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiVerificationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-verification-controller
   * @name SendIdNowLinkTextByVerificationId
   * @request POST:/api/v1/verification/personal/id-now-text-message/{verificationId}
   * @deprecated
   */
  sendIdNowLinkTextByVerificationId = (verificationId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/verification/personal/id-now-text-message/${verificationId}`,
      method: 'POST',
      ...params,
    })

  static sendIdNowLinkTextByVerificationIdPath =
    '/v1/verification/personal/id-now-text-message/${verificationId}'
  static sendIdNowLinkTextByVerificationIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-verification-controller
   * @name Get
   * @request GET:/api/v1/verification/identity/{id}
   */
  get = (id: string, params: RequestParams = {}) =>
    this.http.request<IdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto, any>({
      path: `/v1/verification/identity/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/verification/identity/${id}'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags api-verification-controller
   * @name InitialiseIfNotInitialised
   * @request POST:/api/v1/verification/identity/{id}
   */
  initialiseIfNotInitialised = (
    id: string,
    data: InitiateIdVerificationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<IdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto, any>({
      path: `/v1/verification/identity/${id}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initialiseIfNotInitialisedPath = '/v1/verification/identity/${id}'
  static initialiseIfNotInitialisedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-verification-controller
   * @name Start
   * @request POST:/api/v1/verification/identity/{id}/start
   */
  start = (id: string, params: RequestParams = {}) =>
    this.http.request<IdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto, any>({
      path: `/v1/verification/identity/${id}/start`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static startPath = '/v1/verification/identity/${id}/start'
  static startMethod = 'POST'
  /**
   * No description
   *
   * @tags api-verification-controller
   * @name SendSms
   * @request POST:/api/v1/verification/identity/{id}/send-sms
   */
  sendSms = (id: string, params: RequestParams = {}) =>
    this.http.request<IdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto, any>({
      path: `/v1/verification/identity/${id}/send-sms`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static sendSmsPath = '/v1/verification/identity/${id}/send-sms'
  static sendSmsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-verification-controller
   * @name Retry
   * @request POST:/api/v1/verification/identity/{id}/retry
   */
  retry = (id: string, params: RequestParams = {}) =>
    this.http.request<IdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto, any>({
      path: `/v1/verification/identity/${id}/retry`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static retryPath = '/v1/verification/identity/${id}/retry'
  static retryMethod = 'POST'
}
